import { render, staticRenderFns } from "./UpdateVessel.vue?vue&type=template&id=33aecdc2&scoped=true"
import script from "./UpdateVessel.vue?vue&type=script&lang=js"
export * from "./UpdateVessel.vue?vue&type=script&lang=js"
import style0 from "./UpdateVessel.vue?vue&type=style&index=0&id=33aecdc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33aecdc2",
  null
  
)

export default component.exports